import { lazyShowNotification } from 'owa-notification-bar';
import strings from 'owa-strings/owa-mail-strings';
import { format } from 'owa-strings';
import folderStore from 'owa-folders';
/**
 * This method shows notification when shared folder move action fails
 * @param destinationFolderId - destination folderId for which move items action failed
 */
export default function showNotificationOnMoveFailure(destinationFolderId) {
    var destinationFolderName = folderStore.folderTable.get(destinationFolderId).DisplayName;
    lazyShowNotification.importAndExecute('moveSharedFolderItems', format(strings.moveItemFailedNotification, destinationFolderName));
}
//# sourceMappingURL=showNotificationOnMoveFailure .js.map